/** Parse a hand-typed / pasted transaction-id entry.
 *
 *  The NV workflow pastes IDs straight from the labelling sheet or
 *  NetSuite — one at a time or several separated by commas, spaces, or
 *  newlines. Dedupes while preserving entry order and drops ids
 *  already selected.
 */
export function parseTransactionIds(raw: string, alreadySelected: string[]): string[] {
  const seen = new Set(alreadySelected);
  const out: string[] = [];
  for (const token of raw.split(/[\s,;]+/)) {
    const id = token.trim();
    if (id.length === 0 || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}
